import { render } from "./TaskAttachments.vue?vue&type=template&id=3f2b5285"
import script from "./TaskAttachments.vue?vue&type=script&lang=js"
export * from "./TaskAttachments.vue?vue&type=script&lang=js"

import "./TaskAttachments.vue?vue&type=style&index=0&id=3f2b5285&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QVideo from 'quasar/src/components/video/QVideo.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QInput,QBtn,QImg,QVideo});
